import { fetchData } from '../../fetchapi/fetchapi';

export class Endpoint {
  constructor(endpoint) {
    this.endpoint = endpoint
  }
  async list(orderBy = '', limit = 0, offset = 0) {
    const response = await fetchData(`${this.endpoint}`, { orderBy, limit: limit || undefined, offset: offset || undefined });
    return response.data;
  }

  async listWithTotal(orderBy = '', limit = 0, offset = 0) {
    const response = await fetchData(`${this.endpoint}`, { orderBy, limit: limit || undefined, offset: offset || undefined });
    return response; // Returns { data, total }
  }

  async get(id) {
    return fetchData(`${this.endpoint}?` + id);
  }

  async create(data) {
    return fetchData(`${this.endpoint}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json"
        }
    });
  }

  async update(id, data) {
    return fetchData(`${this.endpoint}/` + id, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json"
        }
    });
  }

  async delete(id) {
    return fetchData(`${this.endpoint}/` + id, { method: 'DELETE' });
  }

  async filter(filters = {}, orderBy = '', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams();

    // Append filters
    for (const key in filters) {
        if (filters.hasOwnProperty(key)) {
            queryParams.append(key, filters[key]);
        }
    }

    // Append sorting parameter with the correct key 'sort'
    if (orderBy) {
        queryParams.append('sort', orderBy);
    }

    // Append limit if provided
    if (limit) {
        queryParams.append('limit', limit);
    }

    // Append offset if provided
    if (offset) {
        queryParams.append('offset', offset);
    }

    const response = await fetchData(`filter/${this.endpoint}?` + queryParams.toString());
    return response.data;
  }

  async filterWithTotal(filters = {}, orderBy = '', limit = 0, offset = 0, search = '', searchColumns = []) {
    const queryParams = new URLSearchParams();

    // Append filters
    for (const key in filters) {
        if (filters.hasOwnProperty(key)) {
            queryParams.append(key, filters[key]);
        }
    }

    // Append sorting parameter with the correct key 'sort'
    if (orderBy) {
        queryParams.append('sort', orderBy);
    }

    // Append limit if provided
    if (limit) {
        queryParams.append('limit', limit);
    }

    // Append offset if provided
    if (offset) {
        queryParams.append('offset', offset);
    }

    // Append search if provided
    if (search) {
        queryParams.append('search', search);
    }

    // Append searchColumns if provided
    if (searchColumns.length > 0) {
        queryParams.append('searchColumns', searchColumns.join(','));
    }

    const response = await fetchData(`filter/${this.endpoint}?` + queryParams.toString());
    return response; // Returns { data, total }
  }

  async customRequest(path) {
    return fetchData(path);
  }

  async getDistinctValues(column, search = '', limit = 10) {
    const queryParams = new URLSearchParams();
    if (search) queryParams.append('search', search);
    if (limit) queryParams.append('limit', limit);
    const queryString = queryParams.toString();
    const response = await fetchData(`${this.endpoint}/distinct/${column}${queryString ? '?' + queryString : ''}`);
    return response.values || [];
  }
}
